// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-alert.v-sheet[data-v-4c090736]{background-color:#fdebe2 !important;font-size:12px}.v-input.v-select[data-v-4c090736]{padding-top:0}.v-input.v-select[data-v-4c090736] div.v-select__slot{background-color:#f6f6f6;height:36px}.v-input.v-select[data-v-4c090736] div.v-select__selection{padding-left:8px}", ""]);
// Exports
module.exports = exports;
